export default __webpack_public_path__ + "static/media/hen.6219bf61.svg";